/* Okholm Studio – Julebuketter 2026: diskret scroll-reveal + blød scroll til buketterne.
   Ingen eksterne biblioteker. Respekterer prefers-reduced-motion. */
(function () {
  if (window.JulLanding) return;
  window.JulLanding = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var observer = null;

  function show(el) { el.classList.add('is-visible'); }

  if ('IntersectionObserver' in window && !reduce && !designMode) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          show(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function init(root) {
    var nodes = (root || document).querySelectorAll('.jul-reveal:not(.is-visible)');
    for (var i = 0; i < nodes.length; i++) {
      if (observer) observer.observe(nodes[i]); else show(nodes[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:select', function (e) { init(e.target); });

  function headerOffset() {
    var v = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var n = parseInt(v, 10);
    if (!isNaN(n) && n > 0 && n < 200) return n;
    var header = document.querySelector('.header-sections');
    return header ? Math.min(header.offsetHeight, 140) : 0;
  }

  document.addEventListener('click', function (ev) {
    var link = ev.target.closest ? ev.target.closest('[data-jul-scroll]') : null;
    if (!link) return;
    var href = link.getAttribute('href') || '';
    if (href.charAt(0) !== '#' || href.length < 2) return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    ev.preventDefault();
    var top = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 8;
    try {
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    } catch (err) {
      window.scrollTo(0, top);
    }
    if (window.history && window.history.pushState) window.history.pushState(null, '', href);
    if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
    try { target.focus({ preventScroll: true }); } catch (err) { /* ældre browsere */ }
  });
})();
